import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { GoogleAnalyticsService } from "@edp-services/google-analytics.service";
import { Observable } from "rxjs";
import { EdpResponseBody } from "@edp-models/response.model";

@Injectable({
    providedIn: "root",
})
export class OperationHistoryService {
    constructor(private apiService: ApiService, public googleAnalyticsService: GoogleAnalyticsService) {}

    public registerWithContract(
        contractId: number | string,
        operation: string,
        value: string | number | {} = null,
        oldValue: string | number | {} = null,
        gaAction?: string,
        sendDataLayer: boolean = true,
        cpe?: string,
        Trigger?: string
    ) {
        const body = {
            ContractId: contractId,
            Operation: operation,
            Value: value,
            OldValue: oldValue,
            Cpe: cpe,
            Trigger
        };
        this.apiService.callServicePost("operationHistory.registerHistorical", body).subscribe();

        if (!!sendDataLayer) {
            this.googleAnalyticsService.datalayerEvent(operation, gaAction);
        }
    }

    public registerWithContractObservable(
        contractId: number | string,
        operation: string,
        value: string | number | {} = null,
        oldValue: string | number | {} = null,
        gaAction?: string,
        sendDataLayer: boolean = true,
        cpe?: string,
        Trigger?: number
    ) {
        const body = {
            ContractId: contractId,
            Operation: operation,
            Value: value,
            OldValue: oldValue,
            Cpe: cpe,
            Trigger
        };

        if (!!sendDataLayer) {
            this.googleAnalyticsService.datalayerEvent(operation, gaAction);
        }

        return this.apiService.callServicePost("operationHistory.registerHistorical", body);
    }

    public getOperations() {
        return this.apiService.callServicePostToCollection(`operationHistory.getTemplateOperations`, {});
    }
}
